"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrderLineMargin = void 0;
const dayjs = require("dayjs");
const hotel_1 = require("../hotel");
const getOrderLineMargin = (config, type) => {
    let margin = 0;
    let margin_discount_percentage = 0;
    switch (type) {
        case "GOLF": {
            const golf_config = config;
            const { green_fee, adjustments } = golf_config;
            // Adjustments
            margin_discount_percentage = adjustments?.margin_discount_percentage || 0;
            // Green Fee
            margin =
                green_fee?.margin * golf_config.where_when_who?.number_of_golfers;
            break;
        }
        case "HOTEL": {
            const hotel_config = config;
            const { adjustments, rooms } = hotel_config;
            // Adjustments
            margin_discount_percentage = rooms?.custom
                ? 0
                : adjustments?.margin_discount_percentage || 0;
            margin = hotel_config.rooms.rooms.reduce((acc, room) => {
                const discounts = (0, hotel_1.getFilteredRoomDiscounts)(hotel_config?.date_of_confirmation, hotel_config?.where_when_who?.check_in_date, (0, hotel_1.getApplicableDiscountsForRatePolicies)(room.rate, hotel_config?.where_when_who?.number_of_nights, dayjs(hotel_config?.where_when_who?.check_in_date).diff(dayjs(), "day")));
                const rate_margin = room.rate.reduce((acc, rate) => {
                    let room_margin = rate.margin;
                    if (discounts && discounts.best) {
                        if (discounts.best.discount > 0) {
                            // discount is in 20 format (e.g. 20%)
                            room_margin =
                                room_margin - room_margin * (discounts.best.discount / 100);
                        }
                    }
                    return acc + room_margin;
                }, 0);
                return acc + rate_margin;
            }, 0);
            break;
        }
        case "TRANSFER": {
            const transfer_config = config;
            const { adjustments } = transfer_config;
            // Adjustments
            margin_discount_percentage = adjustments?.margin_discount_percentage || 0;
            margin =
                transfer_config.vehicle.margin * transfer_config.vehicle.quantity;
            break;
        }
        case "EXCURSION": {
            const excursion_config = config;
            const { adjustments } = excursion_config;
            // Adjustments
            margin_discount_percentage = adjustments?.margin_discount_percentage || 0;
            if (!excursion_config?.product?.rate)
                return margin;
            // use the percentage of the margin of the sell price to calculate the margin based on the total
            const percentage = excursion_config?.product?.rate?.margin /
                excursion_config?.product?.rate?.sell_price;
            margin = percentage * excursion_config?.product?.rate?.total;
            break;
        }
        case "CUSTOM": {
            const custom_config = config;
            const { adjustments } = custom_config;
            // Adjustments
            margin_discount_percentage = adjustments?.margin_discount_percentage || 0;
            margin = custom_config?.pricing?.margin || 0;
            break;
        }
    }
    // discount the margin based on the margin_discount_percentage
    margin = margin - (margin * margin_discount_percentage) / 100;
    return margin;
};
exports.getOrderLineMargin = getOrderLineMargin;
